import { useEffect } from 'react';

import useAxiosCallback from './useAxiosCallback';

const useAxios = (axiosConfig: any) => {
    // @ts-expect-error TS2339: Property 'error' does not exist on type 'boolean | ((reqData: any) => void) |  error: string; respon
    const [exec, loading, { error, response, data }] = useAxiosCallback(axiosConfig);

    useEffect(() => {
        // @ts-expect-error TS2349: This expression is not callable.
        exec(axiosConfig);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return [data, loading, { error, response }];
};

export default useAxios;
